import React from 'react'
import { withStyles } from '@material-ui/styles'
import { Translation } from 'react-i18next'
import { Form, useForm, useFieldArray, useWatch, isEmpty } from '../../form'
import PropTypes from 'prop-types'
import InformationComponent from './info.component'
import WorkExperienceComponent from './workExperience.component'
import Button from '@material-ui/core/Button'
import { openForWorkValidate } from '../../containers/validate'
import { Dialog, DialogContent, Snackbar } from '@material-ui/core'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import './Dropbtn.css'
import NavButton from './navButton.component'
import { scrollToTop } from '../../utils/scrollTo'
import PreviewOpenForWorkProfile from './previewOpenForWorkProfile.component'
import { CloseIcon } from './closeIcon.component'
import { usePrompt } from '../../utils/usePromptHook'

/**
 * @author Huong Nguyen
 */

class OpenForWorkComponent extends React.Component {
  componentDidMount() {
    this.props.loadProfileStart()
    this.props.loadOpenForWorkStart()
    this.props.getAreaOfExpertise()
    this.props.getAreaOfWork()
    this.props.getBillableHourUser()
    scrollToTop()
  }

  render() {
    return <OpenForWork {...this.props} />
  }
}

const styles = (theme) => ({
  checkbox: {
    marginTop: theme.spacing(0),
    fontSize: '15px',
    fontWeight: 400,
    color: '#808080'
  },
  select: {
    paddingRight: '0 !important',
    fontSize: '14px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray',
    width: '70%',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  select1: {
    fontSize: '14px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray'
  },
  textfield1: {
    color: '#1E90FF',
    fontSize: '11px'
  },
  textfield: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px'
  },
  textfield2: {
    border: '1px solid gray',
    fontSize: '14px',
    padding: '9px'
  },
  workTime: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  workMonth: {
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  workYear: {
    width: '35%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      '& > div': {
        marginTop: '0px !important'
      }
    }
  },
  richtexteditor: {
    paddingTop: '18px'
  },
  p_label: {
    fontSize: '15px',
    color: '#808080'
  },
  space_row: {
    padding: '5px',
    [theme.breakpoints.down('md')]: {
      padding: '15px'
    }
  },
  error: {
    border: '1px solid red'
  },
  tableCell: {
    fontSize: '14px',
    border: 'none',
    padding: '0px 0px 16px 0px'
  },
  tableHead: {
    fontSize: '14px',
    color: '#808080',
    border: 'none',
    padding: 0
  },
  box: {
    border: '1px solid lightgrey',
    borderRadius: '5px'
  },
  previewLabel: {
    color: 'grey'
  },
  previewValue: {
    fontWeight: 500
  },
  button1: {
    background: '#fff'
  }
})

const rowDefaultValues = {
  CompanyName: '',
  Location: '',
  JobTitle: '',
  start_month: 0,
  start_year: 0,
  end_month: 0,
  end_year: 0,
  Responsibilities: '',
  KeyAchievements: ''
}

const linkRowDefaultValues = {
  link_title: '',
  link_url: ''
}

const defaultValues = {
  IsNotOpenForWork: true,
  RetrieveJobs: false,
  AcceptRatings: false,
  // AreaOfExpertise: '',
  // AreaOfWork: '',
  inputImage: '',
  inputLetter: '',
  letter_file: '',
  inputCV: '',
  CV_file: '',
  experienceInputRow: [rowDefaultValues],
  linkedin_url: '',
  info_consent_allowed: false,
  AreaOf_Expertise: [],
  AreaOf_Work: [],
  role_title: '',
  short_des: '',
  linkRow: [linkRowDefaultValues]
}

// list files uploaded
const initial_files_state = [
  { AttachmentType: 1, FileType: null, Title: null, data: null },
  { AttachmentType: 2, FileType: null, Title: null, data: null },
  { AttachmentType: 3, FileType: null, Title: null, data: null }
]

const OpenForWork = ({
  updateOpenForWork,
  classes,
  showSnackbar,
  showFailSnackbar,
  closeOpenForWorkSnackBar,
  isEdit,
  applicationData,
  areaExpertiseList,
  areaOfWorkList,
  notOpenForWork,
  userData,
  ratingsByCompany,
  ratingsSummary,
  updatedFormSuccess
}) => {
  // state that will hold the array of objects
  // initialized with empty array
  const [files, setFiles] = React.useState(initial_files_state)
  const [blank_picture, set_blank_picture] = React.useState(
    '../../images/blank-profile-picture.png'
  )
  const [portfolios, setPortfolios] = React.useState([])
  const [portfolios_base64data, setPortfolios_base64data] = React.useState([])
  const [isDirty, setIsDirty] = React.useState(false) // Manual form isDirty

  const [submitFailed, setSubmitFailed] = React.useState(false)
  const [attemptingSubmit, setAttemptingSubmit] = React.useState(false)
  const [previewForm, setPreviewForm] = React.useState(false)
  const [formValues, setFormValues] = React.useState({})

  const form = useForm({
    name: 'openforwork',
    onSubmit: onSubmit,
    defaultValues: updatedFormSuccess ? applicationData : defaultValues,
    validator: openForWorkValidate,
    mode: 'onChange',
    resetOnSubmit: false
  })

  const {
    control,
    setValue,
    clearErrors,
    getValues,
    formState: { errors }
  } = form

  const rowState = useFieldArray({
    name: 'experienceInputRow',
    control
  })
  const linkRowState = useFieldArray({
    name: 'linkRow',
    control
  })

  const { fields } = rowState
  const { fields: linkRow_fields, remove: link_removeRow } = linkRowState

  // add experiences row
  function addRow() {
    rowState.append(rowDefaultValues)
  }
  // add link row
  function link_addRow() {
    linkRowState.append(linkRowDefaultValues)
    setIsDirty(true)
  }

  // remove experiences row
  function removeRow(index) {
    rowState.remove(index)
  }
  // remove link row
  // function link_removeRow(index) {
  //   linkRowState.remove(index)
  // }

  function onSubmit(values) {
    updateOpenForWork(values, [...files, ...portfolios_base64data])
  }

  const { IsNotOpenForWork } = useWatch({
    fields: 'IsNotOpenForWork',
    control: control
  })

  React.useEffect(() => {
    if (IsNotOpenForWork === false) {
      setValue('RetrieveJobs', true)
    } else {
      setValue('RetrieveJobs', false)
    }
  }, [IsNotOpenForWork, setValue])

  // loading file data
  React.useEffect(() => {
    if (isEdit) {
      if (
        applicationData.inputImage !== null &&
        applicationData.inputImage !== ''
      ) {
        set_blank_picture(applicationData.inputImage)
      } else {
        set_blank_picture('../../images/blank-profile-picture.png')
      }
      if (applicationData.OpenWorkAttachments.length === 0) {
        setFiles(initial_files_state)
      } else {
        setFiles(
          applicationData.OpenWorkAttachments.filter(
            (el) => el.AttachmentType !== 4
          )
        )
        setPortfolios(
          applicationData.OpenWorkAttachments.filter(
            (el) => el.AttachmentType === 4
          )
        )
      }
    }
  }, [setFiles, set_blank_picture, setPortfolios, isEdit])

  React.useEffect(() => {
    if (attemptingSubmit && !isEmpty(errors)) {
      setSubmitFailed(true)
      setAttemptingSubmit(false)
    }
  }, [attemptingSubmit, setSubmitFailed, errors])

  React.useEffect(() => {
    if (showSnackbar) {
      setIsDirty(false)
    }
  }, [showSnackbar, setIsDirty])

  return (
    <Translation>
      {(t) => {
        usePrompt(isDirty)
        return (
          // <div className="container-big">
          <div className="container">
            <div className="row">
              <div className="dashboard-content-header">
                <h1></h1>
              </div>
            </div>
            <NavButton t={t} type="profile" />
            <Form {...form}>
              <div className="row">
                <div className="dashboard-content-header">
                  <div className="col-xs-12 col-sm-12 col-lg-12">
                    {/* <div className="panel panel-defaulf"> */}
                    <div>
                      {/* <div className="panel-heading">
                        <h3 className="panel-title">{t('dashboard.asetu')}</h3>
                      </div> */}
                      {/* <div className="panel-body"> */}
                      <div>
                        <InformationComponent
                          t={t}
                          classes={classes}
                          control={control}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          IsNotOpenForWork={IsNotOpenForWork}
                          files={files}
                          setFiles={setFiles}
                          blank_picture={blank_picture}
                          set_blank_picture={set_blank_picture}
                          areaExpertiseList={areaExpertiseList}
                          areaOfWorkList={areaOfWorkList}
                          applicationData={applicationData}
                          errorsValid={errors}
                          notOpenForWork={notOpenForWork}
                          linkRow_fields={linkRow_fields}
                          link_addRow={link_addRow}
                          link_removeRow={link_removeRow}
                          portfolios={portfolios}
                          setPortfolios={setPortfolios}
                          portfolios_base64data={portfolios_base64data}
                          setPortfolios_base64data={setPortfolios_base64data}
                          setIsDirty={setIsDirty}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="dashboard-content-header">
                  <div className="col-xs-12 col-sm-12 col-lg-12">
                    <div className="panel panel-defaulf">
                      <div className="panel-heading">
                        <h3 className="panel-title">
                          {t('openForWork.panelHeading')}
                        </h3>
                      </div>
                      <div className="panel-body">
                        {getExperienceRows(
                          fields,
                          classes,
                          control,
                          IsNotOpenForWork,
                          removeRow,
                          errors,
                          setIsDirty
                        )}
                        <div>
                          <div
                            style={{
                              float: 'right',
                              padding: '0px 15px 15px 15px'
                            }}
                          >
                            <Button
                              variant="contained"
                              className={classes.button}
                              onClick={() => {
                                addRow()
                                setIsDirty(true)
                              }}
                              // disabled={
                              //   IsNotOpenForWork === true ? true : false
                              // }
                            >
                              {t('openForWork.button3')}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pull-right">
                <Button
                  variant="outlined"
                  className={classes.button1}
                  onClick={() => {
                    const formValues = getValues()
                    setFormValues(formValues)
                    setPreviewForm(true)
                  }}
                >
                  {t('openForWork.button6')}
                </Button>
                <Button
                  variant="contained"
                  className={classes.button}
                  type="submit"
                  // disabled={IsNotOpenForWork === true ? true : false}
                  onClick={() => setAttemptingSubmit(true)}
                >
                  {t('openForWork.button4')}
                </Button>
              </div>
            </Form>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closeOpenForWorkSnackBar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeOpenForWorkSnackBar()
                }}
                variant="success"
                message={t('openForWork.msg')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showFailSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closeOpenForWorkSnackBar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeOpenForWorkSnackBar()
                }}
                variant="error"
                message={t('openForWork.msg1')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={
                submitFailed &&
                !isEmpty(errors) &&
                errors?.letter_file === undefined &&
                errors?.CV_file === undefined
              }
              autoHideDuration={2000}
              onClose={() => {
                setSubmitFailed(false)
              }}
            >
              <MySnackbarContentWrapper
                variant="error"
                message={t('openForWork.msg2')}
                onClose={() => {
                  setSubmitFailed(false)
                }}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={
                submitFailed &&
                !isEmpty(errors) &&
                (errors?.letter_file === t('validation.pako') ||
                  errors?.CV_file === t('validation.pako'))
              }
              autoHideDuration={2000}
              onClose={() => {
                setSubmitFailed(false)
              }}
            >
              <MySnackbarContentWrapper
                variant="error"
                message={t('openForWork.msg3')}
                onClose={() => {
                  setSubmitFailed(false)
                }}
              />
            </Snackbar>
            <Dialog
              open={previewForm}
              fullWidth
              maxWidth="md"
              onClose={() => {
                setPreviewForm(false)
              }}
            >
              <CloseIcon
                fontSize="large"
                onClick={() => {
                  setPreviewForm(false)
                }}
              />
              <DialogContent>
                <PreviewOpenForWorkProfile
                  t={t}
                  classes={classes}
                  formValues={formValues}
                  profile_pic={blank_picture}
                  userData={userData}
                  portfolios={portfolios_base64data}
                  AreaOf_Expertise={formValues.AreaOf_Expertise}
                  role_title={formValues.role_title}
                  short_des={formValues.short_des}
                  inputCV={formValues.inputCV}
                  CV_file={formValues.CV_file}
                  linkRow={formValues.linkRow}
                  experienceInputRow={formValues.experienceInputRow}
                  ratingsByCompany={ratingsByCompany}
                  ratingsSummary={ratingsSummary}
                  info_consent_allowed={formValues.info_consent_allowed}
                  previewAction="openForWorkProfilePreview"
                />
              </DialogContent>
            </Dialog>
          </div>
        )
      }}
    </Translation>
  )
}

const getExperienceRows = (
  fields,
  classes,
  control,
  IsNotOpenForWork,
  remove,
  errorsValid,
  setIsDirty
) =>
  fields.map((field, index) => (
    <WorkExperienceComponent
      index={index}
      key={field.id}
      classes={classes}
      control={control}
      remove={remove}
      IsNotOpenForWork={IsNotOpenForWork}
      CompanyName={`experienceInputRow.${index}.CompanyName`}
      Location={`experienceInputRow.${index}.Location`}
      JobTitle={`experienceInputRow.${index}.JobTitle`}
      start_month={`experienceInputRow.${index}.start_month`}
      start_year={`experienceInputRow.${index}.start_year`}
      end_month={`experienceInputRow.${index}.end_month`}
      end_year={`experienceInputRow.${index}.end_year`}
      Responsibilities={`experienceInputRow.${index}.Responsibilities`}
      KeyAchievements={`experienceInputRow.${index}.KeyAchievements`}
      errorsValid={
        errorsValid?.experienceInputRow
          ? errorsValid.experienceInputRow[index]
          : []
      }
      setIsDirty={setIsDirty}
    />
  ))

OpenForWorkComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(OpenForWorkComponent)
